module.exports = __webpack_public_path__ + "img/eunice.334d5e8f.jpg";